import type { FC, ReactNode } from "react";

import { Column, Columns, Spacer } from "@aviary";
import { useBreakpoints } from "@shared/hooks";

import { FooterLogos } from "./FooterLogos";
import { FooterPrivacy } from "./FooterPrivacy";

import * as styles from "./AuthFooter.styles";

interface Props {
  children?: ReactNode;
}

const AuthFooter: FC<Props> = ({ children }) => {
  const { tablet } = useBreakpoints();

  const renderContent = () => {
    if (tablet.greaterThan) {
      return (
        <>
          <Column columnWidth={3}>
            <FooterLogos />
          </Column>
          <Column textAlign="center">
            {children}
            <FooterPrivacy />
          </Column>
          <Column columnWidth={3}></Column>
        </>
      );
    }
    return (
      <Column css={styles.mobileWrapper} textAlign="center" columnWidth="narrow">
        {children}
        <Spacer height="double" />
        <FooterLogos />
        <Spacer height="oneHalf" />
        <FooterPrivacy />
      </Column>
    );
  };

  return (
    <footer css={[styles.footer, tablet.greaterThan && styles.topBorder]}>
      <Columns css={styles.wrapper} isMarginless isMultiline>
        {renderContent()}
      </Columns>
    </footer>
  );
};

export { AuthFooter };
